import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  aiPromptManagerInitialState,
  selectedPromptPayload,
  setEditingPayload,
  setModalOpenPayload,
} from './PromptManager.types';

const initialState: aiPromptManagerInitialState = {
  modalOpen: false,
  isEditing: false,
  selectedData: {
    promptId: undefined,
    icon: undefined,
    text: undefined,
  },
};

export const aiPromptManagerReducer = createSlice({
  name: 'promptManager',
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<setModalOpenPayload>) => {
      const { value } = action.payload;
      state.modalOpen = value;
    },
    setEditing: (state, action: PayloadAction<setEditingPayload>) => {
      const { value } = action.payload;
      state.isEditing = value;
    },
    setSelectedData: (state, action: PayloadAction<selectedPromptPayload>) => {
      const { value } = action.payload;
      state.selectedData = value;
    },
  },
});

export const { setModalOpen, setEditing, setSelectedData } = aiPromptManagerReducer.actions;
